module.exports = __webpack_public_path__ + "img/savology-screen-15.0ed6e408.png";